import PropTypes from 'prop-types';

const InlineIconPropType = PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
  regular: PropTypes.func.isRequired,
  active: PropTypes.func.isRequired
})]);
const InnerRefPropType = PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
  current: PropTypes.oneOfType([PropTypes.element, PropTypes.object])
})]);
const RouterLinkPropType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);

export { InlineIconPropType, InnerRefPropType, RouterLinkPropType };
